export default __webpack_public_path__ + "static/track-debt-pay-off-down-1eb9b4d915affc3a1e3a7bf30be9b09c.svg";